import { render, staticRenderFns } from "./assignment-intervention-edit-modal.vue?vue&type=template&id=fb253866&scoped=true"
import script from "./assignment-intervention-edit-modal.vue?vue&type=script&lang=js"
export * from "./assignment-intervention-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./assignment-intervention-edit-modal.vue?vue&type=style&index=0&id=fb253866&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb253866",
  null
  
)

export default component.exports